import { render, staticRenderFns } from "./cart-item-list.vue?vue&type=template&id=016a4962&lang=pug&"
import script from "./cart-item-list.vue?vue&type=script&lang=js&"
export * from "./cart-item-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports